import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Loading from './Loading';

const Button = ({
    type = 'button',
    text = '',
    progress = { total: 0, uploaded: 0 },
    loading = false,
    disabled = false,
    default: defaultBtn = false,
    primary = false,
    white = false,
    info = false,
    extraClass = {},
    minPercent = 5,
    onClick = null
}) => {
    const getClasses = useCallback(() => {
        return classNames({
            'btn': true,
            'btn-loading': true,
            'btn-default': defaultBtn,
            'btn-primary': primary,
            'btn-white': white,
            'btn-info': info,
            'btn-loading_active': loading,
            ...extraClass
        });
    }, [defaultBtn, primary, white, info, loading, extraClass]);

    const getWidth = useCallback(() => {
        if (!progress.total) {
            return 0;
        }

        let percent = progress.uploaded * 100 / progress.total;

        return percent < minPercent ? `${minPercent}%` : `${percent}%`;
    }, [progress.total, progress.uploaded, minPercent]);

    const handleClick = useCallback(() => {
        if (loading || disabled) {
            return;
        }

        onClick && onClick();
    }, [loading, disabled, onClick]);

    const classes = useMemo(() => getClasses(), [getClasses]);
    const width = useMemo(() => getWidth(), [getWidth]);

    return (
        <button
            type={type}
            className={classes}
            disabled={disabled || loading}
            onClick={handleClick}
        >
            <span className="btn-loading__spiner">
                <Loading white={true} inherit={true}/>
            </span>
            <span className="btn-loading__label">{text}</span>
            <span className="btn-loading__progress" style={{width: width}} />
        </button>
    );
};

Button.propTypes = {
    type: PropTypes.string,
    text: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]),
    progress: PropTypes.shape({
        total: PropTypes.number,
        uploaded: PropTypes.number
    }),
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    default: PropTypes.bool,
    primary: PropTypes.bool,
    white: PropTypes.bool,
    info: PropTypes.bool,
    extraClass: PropTypes.object,
    minPercent: PropTypes.number,
    onClick: PropTypes.func
};

export default Button;
